import Sidebar from './Sidebar.vue'
import './sidebar.scss'

export default Sidebar
